import cookies from '../cookies'
import getCurrentDomain from '../getCurrentDomain'

const COOKIE_NAME = 'STV_FEATURE_FLAGS'
const COOKIE_EXPIRY_DAYS = 365

export const setFeatureFlagCookie = (flags, ctx = null) => {
  const expirationDate = new Date()
  expirationDate.setDate(expirationDate.getDate() + COOKIE_EXPIRY_DAYS)

  const cookieOptions = {
    expires: expirationDate,
    path: '/',
    domain: `.${getCurrentDomain(ctx?.req?.hostname)}`,
  }

  const cookieValue = JSON.stringify(flags)

  // Server-side
  if (ctx?.res) {
    cookies.set(COOKIE_NAME, cookieValue, cookieOptions, ctx.res)
  }

  // Client-side
  if (typeof window !== 'undefined') {
    cookies.set(COOKIE_NAME, cookieValue, cookieOptions)
  }
}

export const getFeatureFlagsFromCookie = (ctx = null) => {
  const cookieValue = cookies.get(COOKIE_NAME, ctx?.req)
  if (!cookieValue) return {}

  try {
    return JSON.parse(decodeURIComponent(cookieValue))
  } catch {
    return {}
  }
}
